import React, { useEffect, useState } from "react";
import { ToastContainer } from 'react-toastify';
const Toast = () => {
    // const notify = () => toast("Wow so easy!");

    return (
        <ToastContainer />
    );
};

export default Toast;



